import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { HeaderTdElement } from '@progress/kendo-react-data-tools';
import React, { useState, useEffect, useRef } from 'react';

const GridTextFilter = (
  props: GridCustomFilterCellProps,
  placeholder: string,
  onChange?: (value: string) => void,
  debounceMs?: number
) => {
  const [localValue, setLocalValue] = useState(props.value || '');
  const debounceTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isDebounced = debounceMs !== undefined && debounceMs > 0;

  useEffect(() => {
    if (isDebounced) {
      setLocalValue(props.value || '');
    }
  }, [props.value, isDebounced]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    
    if (isDebounced) {
      setLocalValue(newValue);
      onChange?.(newValue);

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        props.onChange({
          value: newValue,
          operator: props.operator,
          syntheticEvent: event
        });
      }, debounceMs);
    } else {
      onChange?.(newValue);
      props.onChange({
        value: newValue,
        operator: props.operator,
        syntheticEvent: event
      });
    }
  };

  const handleClear = (event: React.MouseEvent) => {
    if (isDebounced) {
      setLocalValue('');
      onChange?.('');

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    } else {
      onChange?.('');
    }

    props.onChange({
      value: '',
      operator: props.operator,
      syntheticEvent: event
    });
  };

  const displayValue = isDebounced ? localValue : props.value;

  return (
    <HeaderTdElement
      columnId={props.thProps?.columnId || ''}
      {...props.thProps}
    >
      <div className="k-filtercell">
        <span className="k-input k-input-md k-rounded-md k-input-solid">
          <input
            type="text"
            className="k-input-inner"
            value={displayValue}
            placeholder={placeholder}
            onChange={handleChange}
          />
          {displayValue && (
            <i
              className="k-icon k-clear-value k-i-close"
              title="clear"
              onClick={handleClear}
            ></i>
          )}
        </span>
      </div>
    </HeaderTdElement>
  );
};

export default GridTextFilter;
